<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sHnykt/tc-custom/9780830841950.jpg?1696363225156" alt="This image is the cover for the book Including the Stranger, New Studies in Biblical Theology"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Including the Stranger, New Studies in Biblical Theology
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>Biblical Foundations Award Finalist</strong> </p> <p>The Old Testament, particularly the Former Prophets (Joshua, Judges, 1-2 Samuel, and 1-2 Kings), has frequently been regarded as having a negative attitude towards foreigners. This has meant that these texts are often employed by those opposed to the Christian faith to attack the Bible—and such views can be echoed by Christians. While the story of David and Goliath is cherished, other episodes are seen to involve "ethnic cleansing" or "massacre" and are avoided.</p> <p>David Firth's contention is that this approach emerges from an established interpretation of the text, but not the text itself. In this New Studies in Biblical Theology volume, he argues that the Former Prophets subvert the exclusivist approach in order to show that the people of God are not defined by ethnicity but rather by their willingness to commit themselves to the purposes of Yahweh. God's purposes are always wider than Israel alone, and Israel must therefore understand themselves as a people who welcome and include the foreigner.</p> <p>Firth addresses contemporary concerns about the ongoing significance of the Old Testament for Christians, and shows how opponents of Christianity have misunderstood the Bible. His reading of the Former Prophets also has significant ethical implications for Christians today as they wrestle with the issues of migration and what it means to be the people of God.</p> <p>Addressing key issues in biblical theology, the works comprising New Studies in Biblical Theology are creative attempts to help Christians better understand their Bibles. The NSBT series is edited by D. A. Carson, aiming to simultaneously instruct and to edify, to interact with current scholarship and to point the way ahead.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David G. Firth, D. A. Carson
      </h2>
      
      <p class="authorDescription body article"><p>David G. Firth is tutor in Old Testament at Trinity College, Bristol. He is the author of <em>1 and 2 Samuel</em> (Apollos Old Testament Commentary), <em>The Message of Esther</em>, and <em>The Message of Joshua</em>, and the coeditor of <em>Interpreting the Psalms</em>, <em>Interpreting Isaiah</em>, <em>Words and the Word</em>, and <em>Presence, Power and Promise</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Apollos
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9c019942